<template>
  <v-container>
    <v-row class="justify-center d-flex mt-n16">
      <v-col lg="4" md="7" class="mx-auto">
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
            <h5 class="text-h5 text-typo font-weight-bold">Verify your email</h5>
            <p class="text-sm text-body mt-2 mb-0">
              <template v-if="pending">
                We sent a verification code to <strong>{{ pending.email }}</strong>.
              </template>
              <template v-else>
                We couldn't find your sign-up in this browser. Please sign up again to get a new code.
              </template>
            </p>
          </div>
          <div class="card-padding">
            <v-text-field
              v-model="code"
              :disabled="!pending"
              hide-details
              outlined
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              height="40"
              placeholder="Verification code"
              autocomplete="one-time-code"
              @keyup.enter="confirm()"
              :class="inputClass"
            >
            </v-text-field>

            <p v-if="errorMessage" class="text-sm text-danger mb-0">{{ errorMessage }}</p>
            <p v-if="infoMessage" class="text-sm text-success mb-0">{{ infoMessage }}</p>

            <v-btn
              v-if="pending"
              @click.prevent="confirm()"
              :loading="loading"
              elevation="0"
              :ripple="false"
              height="43"
              class="font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100"
              color="#5e72e4"
              small
              >Verify</v-btn
            >
            <v-btn
              v-else
              @click.prevent="$router.push({ path: '/pages/authentication/signup/basic' })"
              elevation="0"
              :ripple="false"
              height="43"
              class="font-weight-bold text-uppercase btn-default bg-gradient-default py-2 px-6 me-2 mt-6 mb-2 w-100"
              color="#5e72e4"
              small
              >Sign Up</v-btn
            >
            <p v-if="pending" class="text-sm text-body mt-3 mb-0">
              Didn't get it?
              <a
                @click.prevent="resend()"
                class="ml-2 text-dark text-decoration-none font-weight-bolder"
                >Send a new code</a
              >
            </p>
            <p class="text-sm text-body mt-1 mb-0">
              <a
                @click.prevent="$router.push({ path: '/pages/authentication/login' })"
                class="text-dark text-decoration-none font-weight-bolder"
                >Back to log in</a
              >
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { confirmSignUp, resendSignUpCode, getPendingSignUp, authErrorMessage } from '@/auth/cognito'

export default {
  name: "confirm-sign-up",
  data() {
    return {
      // The generated Cognito username is needed here; email is not an alias until verified.
      pending: getPendingSignUp(),
      code: '',
      loading: false,
      errorMessage: '',
      infoMessage: '',
      inputClass: 'input-style font-size-input border border-radius-md placeholder-lighter text-color-light mb-4',
    };
  },
  methods: {
    async confirm() {
      if (this.loading || !this.pending) return
      this.errorMessage = ''
      this.infoMessage = ''
      this.loading = true
      try {
        await confirmSignUp(this.pending.username, this.code)
        await this.$swal({ icon: 'success', title: 'Email verified', text: 'You can now log in.' })
        this.$router.push({ path: '/pages/authentication/login' })
      } catch (error) {
        this.consoleLog('error', 'ConfirmSignUp.vue fn(confirm): error catch', error)
        this.errorMessage = authErrorMessage(error)
      } finally {
        this.loading = false
      }
    },
    async resend() {
      this.errorMessage = ''
      this.infoMessage = ''
      try {
        await resendSignUpCode(this.pending.username)
        this.infoMessage = 'A new code is on its way.'
      } catch (error) {
        this.errorMessage = authErrorMessage(error)
      }
    },
  },
};
</script>
